import { Wrapper } from "../../layout"
import AmerLabel from "../AmerLabel"

export default function BaseRadioInput({
    label,
    id,
    name,
    bold = true,
    handleChange,
    optionsFlow = "horizontal",
    options = [],
}) {
    return (
        <Wrapper>
            <AmerLabel inputId={id} value={label} bold={bold} />
            <div
                style={{
                    display: "flex",
                    flexFlow: 
                        optionsFlow === 'horizontal' ?
                        "row wrap" :
                        "column nowrap",
                    alignItems: 
                        optionsFlow === 'horizontal' ?
                        "center" :
                        "flex-start",
                    gap: "1rem",
                }}
            >
                {options.map(option => (
                    <label
                        key={option.value}
                        style={{
                            fontSize: ".9rem",
                            color: "#606061",
                            display: "flex",
                            flexFlow: "row nowrap",
                            alignItems: "center",
                            gap: ".5rem"
                        }}
                    >
                        <input 
                            type="radio"
                            name={name}
                            value={option.value}
                            defaultChecked={option.defaultValue}
                            onChange={handleChange}
                        />
                        {option.label}
                    </label>
                ))}
            </div>
        </Wrapper>
    )
}